export default __webpack_public_path__ + "static/star-renci-logo-combined-60edcc68e5a3e6311738262a55a414aa.png";